import MobxReactForm from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';
import {
    webhookFieldDefinitions,
    webhookRuleDefinitions,
} from './webhookFieldDefs';

const rules = {
    requiredIfEmptyArray: webhookRuleDefinitions.requiredIfEmptyArray,
    startsWithHttps: webhookRuleDefinitions.startsWithHttps,
};

const plugins = {
    dvr: dvr({
        package: validatorjs,
        extend: ({ validator }) => {
            Object.keys(rules).forEach((key) =>
                validator.register(key, rules[key].function, rules[key].message)
            );
        },
    }),
};

// Same as the company webhook form, plus the optional company selector
// (options are provided by the container, like the report's lists).
const fields = {
    id: webhookFieldDefinitions.id,
    name: webhookFieldDefinitions.name,
    url: webhookFieldDefinitions.url,
    signatureSecret: webhookFieldDefinitions.signatureSecret,
    company: webhookFieldDefinitions.company,
    types: webhookFieldDefinitions.types,
    allTypes: webhookFieldDefinitions.allTypes,
    enabled: webhookFieldDefinitions.enabled,
};

const options = {
    showErrorsOnReset: false,
};

class PartnerWebhookFormDef extends MobxReactForm {
    constructor(setup, hooks) {
        super({ fields, ...setup }, { plugins, hooks, options });
    }
}

export default PartnerWebhookFormDef;
